import { Prof } from './personne.model';

export class InstanceEtProduit {
    id_produit: number;
    titre_produit: string;
    accroche: string;
    cible: string;
    id_instance: number;
    url_instance: string;
    nom_instance: string;
    question_specifique: string;
    choix_specifiques: string;
    date_debut_instance: string;
    id_forfait: number;
    couleur_background: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.cible = options.cible;
            this.id_instance = options.id_instance;
            this.url_instance = options.url_instance;
            this.nom_instance = options.nom_instance;
            this.question_specifique = options.question_specifique;
            this.choix_specifiques = options.choix_specifiques;
            this.date_debut_instance = options.date_debut_instance;
            this.id_forfait = options.id_forfait;
            this.couleur_background = options.couleur_background;
        }
    }
}

export class Colonne {
    id_colonne: number;
    type_service: string;
    icone: string;
    titre: string;
    sous_titre: string;
    couleur: string;
    position: number;

    constructor(options?: any) {
        if (options) {
            this.id_colonne = options.id_colonne;
            this.type_service = options.type_service;
            this.icone = options.icone;
            this.titre = options.titre;
            this.sous_titre = options.sous_titre;
            this.couleur = options.couleur;
            this.position = options.position;
        }
    }
}

export class ProduitFocus {
    id_produit: number;
    titre_produit: string;
    titre_produit_reduit: string;
    nom_instance: string;
    vignette: string;
    cible: string;
    accroche: string;
    instances: Instance[];
    url: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.titre_produit = options.titre_produit;
            this.titre_produit_reduit = options.titre_produit_reduit;
            this.nom_instance = options.nom_instance;
            this.vignette = options.vignette;
            this.cible = options.cible;
            this.accroche = options.accroche;
            this.instances = options.instances;
            this.url = options.url;
        }
    }
}

export class Instance {
    id: string;
    nom: string;
    url: string;
    url_si_redirection: string;

    constructor(options?: any) {
        if (options) {
            this.id = options.id;
            this.nom = options.nom;
            this.url = options.url;
            this.url_si_redirection = options.url_si_redirection;
        }
    }
}

export class InstanceIds {
    id_instance: number;
    id_si_planning: number;
    id_si_forfait: number;
    id_si_b2b: number;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.id_si_planning = options.id_si_planning;
            this.id_si_forfait = options.id_si_forfait;
            this.id_si_b2b = options.id_si_b2b;
        }
    }
}

export class CoursId {
    id_instance: number;
    id_cours: number;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.id_cours = options.id_cours;
        }
    }
}

export class InscriptionId {
    id_instance: number;
    id_si_forfait: number;
    id_matiere: number;
    id_classe: number;
    id_article: number;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.id_matiere = options.id_matiere;
            this.id_classe = options.id_classe;
            this.id_article = options.id_article;
        }
    }
}

export class ProduitsDisponibles {
    id_produit: number;
    id_testimonial: number;
    titre_produit: string;
    accroche: string;
    vignette: string;
    image_titre: string;
    cible: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    id_instance: string;
    nom_instance: string;
    centres: [];
    focus: string;
    isBulletPointBlack: boolean;
    url: string;
    url_si_redirection: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.id_testimonial = options.id_testimonial;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.image_titre = options.image_titre;
            this.vignette = options.vignette;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.id_instance = options.id_instance;
            this.nom_instance = options.nom_instance;
            this.centres = options.centres;
            this.focus = options.focus;
            this.isBulletPointBlack = options.isBulletPointBlack;
            this.url = options.url;
            this.url_si_redirection = options.url_si_redirection;
        }
    }
}

export class PrepasDisponibles {
    id_produit: number;
    id_testimonial: number;
    titre_produit: string;
    accroche: string;
    vignette: string;
    image_titre: string;
    cible: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    id_instance: string;
    nom_instance: string;
    centres: [];
    focus: string;
    isBulletPointBlack: boolean;
    url: string;
    url_si_redirection: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.id_testimonial = options.id_testimonial;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.image_titre = options.image_titre;
            this.vignette = options.vignette;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.id_instance = options.id_instance;
            this.nom_instance = options.nom_instance;
            this.centres = options.centres;
            this.focus = options.focus;
            this.isBulletPointBlack = options.isBulletPointBlack;
            this.url = options.url;
            this.url_si_redirection = options.url_si_redirection;
        }
    }
}

export class ProduitForfait {
    id_produit: number;
    id_testimonial: number;
    titre_produit: string;
    accroche: string;
    image: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    id_instances: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.id_testimonial = options.id_testimonial;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.image = options.image;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.id_instances = options.id_instances;
        }
    }
}

export class ProduitForfaitInfo {
    id_instance: number;
    id_produit: number;
    id_testimonial: number;
    titre_produit: string;
    accroche: string;
    bandeau: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    cible: string;
    bloc_desc_html1: string;
    bloc_desc_html2: string;
    avantages: string;
    centres: [];
    date_debut_prepa: string;
    date_texte: string;
    id_grille_tarif: number;
    id_forfait: number;
    nom_instance: string;
    nombre_de_jours: number;
    lien_brochure: string;
    url_instance: string;
    case_cgv: number;
    page_diplome: number;
    couleur_background: string;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.id_produit = options.id_produit;
            this.id_testimonial = options.id_testimonial;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.bandeau = options.bandeau;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.bloc_desc_html1 = options.bloc_desc_html1;
            this.bloc_desc_html2 = options.bloc_desc_html2;
            this.avantages = options.avantages;
            this.centres = options.centres;
            this.date_debut_prepa = options.date_debut_prepa;
            this.date_texte = options.date_texte;
            this.id_grille_tarif = options.id_grille_tarif;
            this.id_forfait = options.id_forfait;
            this.nom_instance = options.nom_instance;
            this.nombre_de_jours = options.nombre_de_jours;
            this.lien_brochure = options.lien_brochure;
            this.url_instance = options.url_instance;
            this.case_cgv = options.case_cgv;
            this.page_diplome = options.page_diplome;
            this.couleur_background = options.couleur_background;
        }
    }
}

export class ServicesEcolesDisponibles {
    id_produit: number;
    titre_produit: string;
    accroche: string;
    vignette: string;
    image_titre: string;
    cible: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    id_instance: string;
    nom_instance: string;
    focus: string;
    isBulletPointBlack: boolean;
    url: string;
    url_si_redirection: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.image_titre = options.image_titre;
            this.vignette = options.vignette;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.id_instance = options.id_instance;
            this.nom_instance = options.nom_instance;
            this.focus = options.focus;
            this.isBulletPointBlack = options.isBulletPointBlack;
            this.url = options.url;
            this.url_si_redirection = options.url_si_redirection;
        }
    }
}

export class ServiceEcoleInfo {
    id_produit: number;
    id_testimonial: number;
    titre_produit: string;
    accroche: string;
    bandeau: string;
    labels: string[];
    couleur_box: string;
    couleur_texte: string;
    cible: string;
    bloc_desc_html1: string;
    bloc_desc_html2: string;
    avantages: string;
    id_b2b: number;
    lien_brochure: string;
    url_instance: string;

    constructor(options?: any) {
        if (options) {
            this.id_produit = options.id_produit;
            this.id_testimonial = options.id_testimonial;
            this.titre_produit = options.titre_produit;
            this.accroche = options.accroche;
            this.bandeau = options.bandeau;
            this.labels = options.labels;
            this.couleur_box = options.couleur_box;
            this.couleur_texte = options.couleur_texte;
            this.bloc_desc_html1 = options.bloc_desc_html1;
            this.bloc_desc_html2 = options.bloc_desc_html2;
            this.avantages = options.avantages;
            this.id_b2b = options.id_b2b;
            this.lien_brochure = options.lien_brochure;
            this.url_instance = options.url_instance;
        }
    }
}

export class Forfait {
    id_forfait: number;
    list_id_cours: string;
    cours: CoursForfait[];
    prof: Prof;
    couleurs: CouleurForfait;

    constructor(options?: any) {
        if (options) {
            this.id_forfait = options.id_forfait;
            this.list_id_cours = options.list_id_cours;
            this.cours = options.cours;
            this.prof = options.prof;
            this.couleurs = options.couleurs;
        }
    }
}

export class B2b {
    id_b2b: number;
    list_id_cours: string;
    cours: CoursForfait[];
    prof: Prof;

    constructor(options?: any) {
        if (options) {
            this.id_b2b = options.id_b2b;
            this.list_id_cours = options.id_cours;
            this.cours = options.cours;
            this.prof = options.prof;
        }
    }
}

export class CoursForfait {
    id_cours: number;
    commentaire: string;
    libelle_complet: string;

    constructor(options?: any) {
        if (options) {
            this.id_cours = options.id_cours;
            this.commentaire = options.commentaire;
            this.libelle_complet = options.libelle_complet;
        }
    }
}

export class CouleurForfait {
    couleur_fond_entete: string;
    couleur_texte_entete: string;
    couleur_fond_ligne: string;
    couleur_texte_ligne: string;

    constructor(options?: any) {
        if (options) {
            this.couleur_fond_entete = options.couleur_fond_entete;
            this.couleur_texte_entete = options.couleur_texte_entete;
            this.couleur_fond_ligne = options.couleur_fond_ligne;
            this.couleur_texte_ligne = options.couleur_texte_ligne;
        }
    }
}

export class Horaires {
    heure_deb: string;
    heure_fin: string;

    constructor(options?: any) {
        if (options) {
            this.heure_deb = options.heure_deb;
            this.heure_fin = options.heure_fin;
        }
    }
}
